import styled from "styled-components";

import { ProfileLegalStyledProps as Props } from "./ProfileLegal.types";
import { CONSTANTS } from "config/constants";

const { tablet, desktop } = CONSTANTS.BREAKPOINTS;

const ProfileLegalStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: var(--sizes-navbar-height);
  background-color: var(--palette-gray-s0-l97);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;

  @media (max-width: ${tablet}px) {
    padding-top: var(--sizes-navbar-height-mobile-without-search);
  }

  .ProfileLegal {
    &__header {
      grid-column: fullBleed;
    }

    &__main {
      grid-column: content;
      display: grid;
      grid-template-columns: 28.4rem 1fr;
      gap: 5.2rem;
      grid-template-areas: ". content";
      padding-top: 3.4rem;

      @media (max-width: ${desktop}px) {
        grid-template-columns: 30rem 1fr;
      }

      @media (max-width: ${tablet}px) {
        grid-template-columns: 1fr;
        grid-template-areas: "content";
        grid-column: fullBleed;
      }
    }

    &__navigation {
      max-width: 28rem;
      position: fixed;
    }

    &__navigation,
    &__breadcrumb {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      padding-bottom: 6.4rem;
      grid-area: content;

      &__header {
        @media (max-width: ${tablet}px) {
          padding-top: 3.4rem;
        }
      }

      &__title {
        padding-left: 1.6rem;
        padding-top: 1.2rem;
        font-weight: 600;
        font-size: 2.8rem;
        line-height: 3.6rem;
        font-weight: 600;
        color: var(--palette-black-s0-l10);
        padding-bottom: 4rem;
      }

      &__links {
        display: flex;
        flex-direction: column;
        gap: 4rem;
        background-color: var(--palette-white);
        border-radius: 1.2rem;
        padding: 2rem 1.6rem;
      }
    }

    &__footer {
      grid-column: fullBleed;
    }
  }
`;

export default ProfileLegalStyled;
